// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"9fe9b391","156":"6c9492be","438":"387cc76a","706":"7771651d","726":"19dfc66e","785":"4121545d"}[chunkId] + ".chunk.js";
};